import React from "react";
import Chat from "./chat"

const Viewrequest = () => {
  return (
    <div className="container">
      <Chat/>
      {/* <div className="row ">
        
        <div className="col-xl-12">
          <div className="row">
            <div className=" col-lg-4 my-2 items">
              <div className="card1 shadow contact-bx item-content">
                <div className="card-header border-0">
                  <div className="action-dropdown">
                    <div className="dropdown ">
                      <div className="btn-link" data-bs-toggle="dropdown">
                        <svg
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle
                            cx="12.4999"
                            cy="3.5"
                            r="2.5"
                            fill="#A5A5A5"
                          />
                          <circle
                            cx="12.4999"
                            cy="11.5"
                            r="2.5"
                            fill="#A5A5A5"
                          />
                          <circle
                            cx="12.4999"
                            cy="19.5"
                            r="2.5"
                            fill="#A5A5A5"
                          />
                        </svg>
                      </div>
                      <div className="dropdown-menu dropdown-menu-right">
                        <a className="dropdown-item" href="javascript:void(0)">
                          Delete
                        </a>
                        <a className="dropdown-item" href="javascript:void(0)">
                          Edit
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-custom-body user-profile">
                  <div className="image-bx">
                    <img
                      src="https://wms.advanceagro.net/WSVIS/api/Face/GetImage?CardID=15229&size=320"
                      data-src="images/contacts/Untitled-3.jpg"
                      alt=""
                      className="rounded-circle"
                    />
                    <span className="active" />
                  </div>
                  <div className="media-body user-meta-info">
                    <h6 className="fs-4 font-w600 my-1">
                      <span
                        href="app-profile.html"
                        className="text-black user-name"
                        data-name="Alan Green"
                      >
                        บงกฎ คงมาลัย
                      </span>
                    </h6>
                    <p
                      className="fs-14 mb-3 user-work"
                      data-occupation="UI Designer"
                    >
                     Financial
                    </p>
                    <ul>
                      <li>
                        <a href="javascript:void(0);">
                          <i className="fas fa-phone-alt" />
                        </a>
                      </li>
                      <li>
                        <a href="javascript:void(0);">
                          <i className="far fa-comment-alt" />
                        </a>
                      </li>
                      <li>
                        <a href="javascript:void(0);">
                          <i className="fas fa-video" />
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4  my-2 items">
              <div className="card1 shadow contact-bx item-content">
                <div className="card-header border-0">
                  <div className="action-dropdown">
                    <div className="dropdown ">
                      <div className="btn-link" data-bs-toggle="dropdown">
                        <svg
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle
                            cx="12.4999"
                            cy="3.5"
                            r="2.5"
                            fill="#A5A5A5"
                          />
                          <circle
                            cx="12.4999"
                            cy="11.5"
                            r="2.5"
                            fill="#A5A5A5"
                          />
                          <circle
                            cx="12.4999"
                            cy="19.5"
                            r="2.5"
                            fill="#A5A5A5"
                          />
                        </svg>
                      </div>
                      <div className="dropdown-menu dropdown-menu-right">
                        <a className="dropdown-item" href="javascript:void(0)">
                          Delete
                        </a>
                        <a className="dropdown-item" href="javascript:void(0)">
                          Edit
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-body user-profile">
                  <div className="image-bx">
                    <img
                      src="http://wms.advanceagro.net/WSVIS/api/Face/GetImage?CardID=18492872&size=320"
                      data-src="images/contacts/Untitled-3.jpg"
                      alt=""
                      className="rounded-circle"
                    />
                    <span className="active" />
                  </div>
                  <div className="media-body user-meta-info">
                    <h6 className="fs-4 font-w600 my-1">
                      <span
                        href="app-profile.html"
                        className="text-black user-name"
                        data-name="Alan Green"
                      >
                       วันวิสา เทพตาแสง
                      </span>
                    </h6>
                    <p
                      className="fs-14 mb-3 user-work"
                      data-occupation="UI Designer"
                    >
                     IT & Deverloper
                    </p>
                    <ul>
                      <li>
                        <a href="">
                          <i className="fas fa-phone-alt" />
                        </a>
                      </li>
                      <li>
                        <a href="">
                          <i className="far fa-comment-alt" />
                        </a>
                      </li>
                      <li>
                        <a href="">
                          <i className="fas fa-video" />
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4  my-2 tems">
              <div className="card1 shadow contact-bx item-content">
                <div className="card-header border-0">
                  <div className="action-dropdown">
                    <div className="dropdown ">
                      <div className="btn-link" data-bs-toggle="dropdown">
                        <svg
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle
                            cx="12.4999"
                            cy="3.5"
                            r="2.5"
                            fill="#A5A5A5"
                          />
                          <circle
                            cx="12.4999"
                            cy="11.5"
                            r="2.5"
                            fill="#A5A5A5"
                          />
                          <circle
                            cx="12.4999"
                            cy="19.5"
                            r="2.5"
                            fill="#A5A5A5"
                          />
                        </svg>
                      </div>
                      <div className="dropdown-menu dropdown-menu-right">
                       
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-body user-profile">
                  <div className="image-bx">
                    <img
                      src="https://i.pinimg.com/736x/4c/42/a1/4c42a1095b410a7ae267847ba1b11773.jpg"
                      data-src="images/contacts/Untitled-3.jpg"
                      alt=""
                      className="rounded-circle"
                    />
                    <span className="active" />
                  </div>
                  <div className="media-body user-meta-info">
                    <h6 className="fs-4 font-w600 my-1">
                      <span
                        href="app-profile.html"
                        className="text-black user-name"
                        data-name="Alan Green"
                      >
                       พรรณิภา แสงโตลาการ
                      </span>
                    </h6>
                    <p
                      className="fs-14 mb-3 user-work"
                      data-occupation="UI Designer"
                    >
                      Redblue Studios
                    </p>
                    <ul>
                      <li>
                        <a href="javascript:void(0);">
                          <i className="fas fa-phone-alt" />
                        </a>
                      </li>
                      <li>
                        <a href="javascript:void(0);">
                          <i className="far fa-comment-alt" />
                        </a>
                      </li>
                      <li>
                        <a href="javascript:void(0);">
                          <i className="fas fa-video" />
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className=" col-lg-4 my-2 items">
              <div className="card1 shadow contact-bx item-content">
                <div className="card-header border-0">
                  <div className="action-dropdown">
                    <div className="dropdown ">
                      <div className="btn-link" data-bs-toggle="dropdown">
                        <svg
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle
                            cx="12.4999"
                            cy="3.5"
                            r="2.5"
                            fill="#A5A5A5"
                          />
                          <circle
                            cx="12.4999"
                            cy="11.5"
                            r="2.5"
                            fill="#A5A5A5"
                          />
                          <circle
                            cx="12.4999"
                            cy="19.5"
                            r="2.5"
                            fill="#A5A5A5"
                          />
                        </svg>
                      </div>
                      <div className="dropdown-menu dropdown-menu-right">
                        <a className="dropdown-item" href="javascript:void(0)">
                          Delete
                        </a>
                        <a className="dropdown-item" href="javascript:void(0)">
                          Edit
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-custom-body user-profile">
                  <div className="image-bx">
                    <img
                      src="https://i.pinimg.com/736x/4c/42/a1/4c42a1095b410a7ae267847ba1b11773.jpg"
                      data-src="images/contacts/Untitled-3.jpg"
                      alt=""
                      className="rounded-circle"
                    />
                    <span className="active" />
                  </div>
                  <div className="media-body user-meta-info">
                    <h6 className="fs-4 font-w600 my-1">
                      <span
                        href="app-profile.html"
                        className="text-black user-name"
                        data-name="Alan Green"
                      >
                        บงกฎ คงมาลัย
                      </span>
                    </h6>
                    <p
                      className="fs-14 mb-3 user-work"
                      data-occupation="UI Designer"
                    >
                     Financial
                    </p>
                    <ul>
                      <li>
                        <a href="javascript:void(0);">
                          <i className="fas fa-phone-alt" />
                        </a>
                      </li>
                      <li>
                        <a href="javascript:void(0);">
                          <i className="far fa-comment-alt" />
                        </a>
                      </li>
                      <li>
                        <a href="javascript:void(0);">
                          <i className="fas fa-video" />
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4  my-2 items">
              <div className="card1 shadow contact-bx item-content">
                <div className="card-header border-0">
                  <div className="action-dropdown">
                    <div className="dropdown ">
                      <div className="btn-link" data-bs-toggle="dropdown">
                        <svg
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle
                            cx="12.4999"
                            cy="3.5"
                            r="2.5"
                            fill="#A5A5A5"
                          />
                          <circle
                            cx="12.4999"
                            cy="11.5"
                            r="2.5"
                            fill="#A5A5A5"
                          />
                          <circle
                            cx="12.4999"
                            cy="19.5"
                            r="2.5"
                            fill="#A5A5A5"
                          />
                        </svg>
                      </div>
                      <div className="dropdown-menu dropdown-menu-right">
                        <a className="dropdown-item" href="javascript:void(0)">
                          Delete
                        </a>
                        <a className="dropdown-item" href="javascript:void(0)">
                          Edit
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-body user-profile">
                  <div className="image-bx">
                    <img
                      src="https://cf.shopee.co.th/file/3779e59bc69369af86eb7a14ce4d3a0a"
                      data-src="images/contacts/Untitled-3.jpg"
                      alt=""
                      className="rounded-circle"
                    />
                    <span className="active" />
                  </div>
                  <div className="media-body user-meta-info">
                    <h6 className="fs-4 font-w600 my-1">
                      <span
                        href="app-profile.html"
                        className="text-black user-name"
                        data-name="Alan Green"
                      >
                       วันวิสา เทพตาแสง
                      </span>
                    </h6>
                    <p
                      className="fs-14 mb-3 user-work"
                      data-occupation="UI Designer"
                    >
                     IT & Deverloper
                    </p>
                    <ul>
                      <li>
                        <a href="">
                          <i className="fas fa-phone-alt" />
                        </a>
                      </li>
                      <li>
                        <a href="">
                          <i className="far fa-comment-alt" />
                        </a>
                      </li>
                      <li>
                        <a href="">
                          <i className="fas fa-video" />
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4  my-2 tems">
              <div className="card1 shadow contact-bx item-content">
                <div className="card-header border-0">
                  <div className="action-dropdown">
                    <div className="dropdown ">
                      <div className="btn-link" data-bs-toggle="dropdown">
                        <svg
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle
                            cx="12.4999"
                            cy="3.5"
                            r="2.5"
                            fill="#A5A5A5"
                          />
                          <circle
                            cx="12.4999"
                            cy="11.5"
                            r="2.5"
                            fill="#A5A5A5"
                          />
                          <circle
                            cx="12.4999"
                            cy="19.5"
                            r="2.5"
                            fill="#A5A5A5"
                          />
                        </svg>
                      </div>
                      <div className="dropdown-menu dropdown-menu-right">
                       
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-body user-profile">
                  <div className="image-bx">
                    <img
                      src="https://wms.advanceagro.net/WSVIS/api/Face/GetImage?CardID=630002&size=320"
                      data-src="images/contacts/Untitled-3.jpg"
                      alt=""
                      className="rounded-circle"
                    />
                    <span className="active" />
                  </div>
                  <div className="media-body user-meta-info">
                    <h6 className="fs-4 font-w600 my-1">
                      <span
                        href="app-profile.html"
                        className="text-black user-name"
                        data-name="Alan Green"
                      >
                       พรรณิภา แสงโตลาการ
                      </span>
                    </h6>
                    <p
                      className="fs-14 mb-3 user-work"
                      data-occupation="UI Designer"
                    >
                      Redblue Studios
                    </p>
                    <ul>
                      <li>
                        <a href="javascript:void(0);">
                          <i className="fas fa-phone-alt" />
                        </a>
                      </li>
                      <li>
                        <a href="javascript:void(0);">
                          <i className="far fa-comment-alt" />
                        </a>
                      </li>
                      <li>
                        <a href="javascript:void(0);">
                          <i className="fas fa-video" />
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className=" col-lg-4 my-2 items">
              <div className="card1 shadow contact-bx item-content">
                <div className="card-header border-0">
                  <div className="action-dropdown">
                    <div className="dropdown ">
                      <div className="btn-link" data-bs-toggle="dropdown">
                        <svg
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle
                            cx="12.4999"
                            cy="3.5"
                            r="2.5"
                            fill="#A5A5A5"
                          />
                          <circle
                            cx="12.4999"
                            cy="11.5"
                            r="2.5"
                            fill="#A5A5A5"
                          />
                          <circle
                            cx="12.4999"
                            cy="19.5"
                            r="2.5"
                            fill="#A5A5A5"
                          />
                        </svg>
                      </div>
                      <div className="dropdown-menu dropdown-menu-right">
                        <a className="dropdown-item" href="javascript:void(0)">
                          Delete
                        </a>
                        <a className="dropdown-item" href="javascript:void(0)">
                          Edit
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-custom-body user-profile">
                  <div className="image-bx">
                    <img
                      src="https://wms.advanceagro.net/WSVIS/api/Face/GetImage?CardID=15229&size=320"
                      data-src="images/contacts/Untitled-3.jpg"
                      alt=""
                      className="rounded-circle"
                    />
                    <span className="active" />
                  </div>
                  <div className="media-body user-meta-info">
                    <h6 className="fs-4 font-w600 my-1">
                      <span
                        href="app-profile.html"
                        className="text-black user-name"
                        data-name="Alan Green"
                      >
                        บงกฎ คงมาลัย
                      </span>
                    </h6>
                    <p
                      className="fs-14 mb-3 user-work"
                      data-occupation="UI Designer"
                    >
                     Financial
                    </p>
                    <ul>
                      <li>
                        <a href="javascript:void(0);">
                          <i className="fas fa-phone-alt" />
                        </a>
                      </li>
                      <li>
                        <a href="javascript:void(0);">
                          <i className="far fa-comment-alt" />
                        </a>
                      </li>
                      <li>
                        <a href="javascript:void(0);">
                          <i className="fas fa-video" />
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4  my-2 items">
              <div className="card1 shadow contact-bx item-content">
                <div className="card-header border-0">
                  <div className="action-dropdown">
                    <div className="dropdown ">
                      <div className="btn-link" data-bs-toggle="dropdown">
                        <svg
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle
                            cx="12.4999"
                            cy="3.5"
                            r="2.5"
                            fill="#A5A5A5"
                          />
                          <circle
                            cx="12.4999"
                            cy="11.5"
                            r="2.5"
                            fill="#A5A5A5"
                          />
                          <circle
                            cx="12.4999"
                            cy="19.5"
                            r="2.5"
                            fill="#A5A5A5"
                          />
                        </svg>
                      </div>
                      <div className="dropdown-menu dropdown-menu-right">
                        <a className="dropdown-item" href="javascript:void(0)">
                          Delete
                        </a>
                        <a className="dropdown-item" href="javascript:void(0)">
                          Edit
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-body user-profile">
                  <div className="image-bx">
                    <img
                      src="https://i.pinimg.com/736x/4c/42/a1/4c42a1095b410a7ae267847ba1b11773.jpg"
                      data-src="images/contacts/Untitled-3.jpg"
                      alt=""
                      className="rounded-circle"
                    />
                    <span className="active" />
                  </div>
                  <div className="media-body user-meta-info">
                    <h6 className="fs-4 font-w600 my-1">
                      <span
                        href="app-profile.html"
                        className="text-black user-name"
                        data-name="Alan Green"
                      >
                       วันวิสา เทพตาแสง
                      </span>
                    </h6>
                    <p
                      className="fs-14 mb-3 user-work"
                      data-occupation="UI Designer"
                    >
                     IT & Deverloper
                    </p>
                    <ul>
                      <li>
                        <a href="">
                          <i className="fas fa-phone-alt" />
                        </a>
                      </li>
                      <li>
                        <a href="">
                          <i className="far fa-comment-alt" />
                        </a>
                      </li>
                      <li>
                        <a href="">
                          <i className="fas fa-video" />
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4  my-2 tems">
              <div className="card1 shadow contact-bx item-content">
                <div className="card-header border-0">
                  <div className="action-dropdown">
                    <div className="dropdown ">
                      <div className="btn-link" data-bs-toggle="dropdown">
                        <svg
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle
                            cx="12.4999"
                            cy="3.5"
                            r="2.5"
                            fill="#A5A5A5"
                          />
                          <circle
                            cx="12.4999"
                            cy="11.5"
                            r="2.5"
                            fill="#A5A5A5"
                          />
                          <circle
                            cx="12.4999"
                            cy="19.5"
                            r="2.5"
                            fill="#A5A5A5"
                          />
                        </svg>
                      </div>
                      <div className="dropdown-menu dropdown-menu-right">
                      
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-body user-profile">
                  <div className="image-bx">
                    <img
                      src="https://img.kapook.com/u/2019/jutharat/w1/za23_8.jpg"
                      data-src="images/contacts/Untitled-3.jpg"
                      alt=""
                      className="rounded-circle"
                    />
                    <span className="active" />
                  </div>
                  <div className="media-body user-meta-info">
                    <h6 className="fs-4 font-w600 my-1">
                      <span
                        href="app-profile.html"
                        className="text-black user-name"
                        data-name="Alan Green"
                      >
                       พรรณิภา แสงโตลาการ
                      </span>
                    </h6>
                    <p
                      className="fs-14 mb-3 user-work"
                      data-occupation="UI Designer"
                    >
                      Redblue Studios
                    </p>
                    <ul>
                      <li>
                        <a href="javascript:void(0);">
                          <i className="fas fa-phone-alt" />
                        </a>
                      </li>
                      <li>
                        <a href="javascript:void(0);">
                          <i className="far fa-comment-alt" />
                        </a>
                      </li>
                      <li>
                        <a href="javascript:void(0);">
                          <i className="fas fa-video" />
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default Viewrequest;
